export const SENSITIVE_PAGES_TOKEN_KEY = "ttt_sensitive_pages_token";
export const SENSITIVE_PAGES_EXPIRED_EVENT = "ttt-sensitive-pages-expired";

const SENSITIVE_API_ROUTES = [
  "analytics",
  "daily-snapshot",
  "daily-snapshots",
  "expense-summary",
];

function normalizeApiPath(url) {
  const path = String(url || "").split("?")[0];
  if (path.startsWith("/api/")) return path.slice(5);
  return path.replace(/^\//, "");
}

export function getSensitivePagesToken() {
  return sessionStorage.getItem(SENSITIVE_PAGES_TOKEN_KEY);
}

export function setSensitivePagesToken(token) {
  sessionStorage.setItem(SENSITIVE_PAGES_TOKEN_KEY, token);
}

export function clearSensitivePagesToken() {
  sessionStorage.removeItem(SENSITIVE_PAGES_TOKEN_KEY);
}

export function notifySensitivePagesExpired() {
  window.dispatchEvent(new Event(SENSITIVE_PAGES_EXPIRED_EVENT));
}

export function isSensitiveApiUrl(url) {
  const normalized = normalizeApiPath(url);
  if (!normalized) return false;
  return SENSITIVE_API_ROUTES.some(
    (route) => normalized === route || normalized.startsWith(`${route}/`)
  );
}
